import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import RecyclingIcon from "@mui/icons-material/Recycling";

const EXPLANATION =
  "An earlier re-check raised the same finding for this document and it was kept, so this " +
  "item was dismissed automatically instead of re-opening for review.";

/** Marks a review decision reused from an earlier batch job rather than made in this one; the
 *  tooltip explains why the item never reached the review queue. */
export function CarriedForwardBadge() {
  return (
    <Tooltip title={EXPLANATION}>
      <Chip icon={<RecyclingIcon />} label="Carried forward" size="small" variant="outlined" />
    </Tooltip>
  );
}
